const { fetchWithRetry } = require('./utils'); // Utility function to parse cookies  

// Function to create a new group  
const createGroup = async (groupData) => {
  try {
    const response = await fetchWithRetry('/api/groups', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(groupData),
    });

    const responseBodyText = await response.text();
    let parsed;

    try {
      parsed = responseBodyText ? JSON.parse(responseBodyText) : {};
    } catch (e) {
      parsed = { raw: responseBodyText };
    }

    if (!response.ok) {
      const messageFromServer =
        parsed.error ||
        parsed.message ||
        response.statusText ||
        'Failed to create group';

      const error = new Error(messageFromServer);
      error.status = response.status;
      error.data = parsed;
      throw error;
    }

    return parsed;
  } catch (error) {
    console.error('Error creating group:', error);
    throw error;
  }
};

// Function to search groups  
const searchGroups = async ({ role, page = 1, pageSize = 10, round, search }) => {  
    try {  
      const response = await fetchWithRetry('/api/groups/search', {  
        method: 'POST',  
        headers: { 'Content-Type': 'application/json' },  
        body: JSON.stringify({ role, page, pageSize, round, search }),  
      });  
      if (!response.ok) {  
        throw new Error(`Error searching groups: ${response.statusText}`);  
      }  
      return await response.json();  
    } catch (error) {  
      console.error('Error searching groups:', error);  
      throw error;  
    }  
  };  

// Function to search groups by user  
const searchGroupsByUser = async () => {
    try {
        const response = await fetchWithRetry('/api/groups/searchByUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error searching groups by user: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error searching groups by user:', error);
        throw error;
    }
};

// Function to get groups  
const getGroups = async () => {
    try {
        const response = await fetchWithRetry('/api/groups', {
            method: 'GET',
            headers: {},
        });

        if (!response.ok) {
            throw new Error(`Error fetching groups: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching groups:', error);
        throw error;
    }
};

// Function to delete a group  
const deleteGroup = async (groupId) => {
    try {
        const response = await fetchWithRetry('/api/groups', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: groupId }),
        });

        if (!response.ok) {
            throw new Error(`Error deleting group: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error deleting group:', error);
        throw error;
    }
};

// Function to get a group by ID  
const getGroupById = async (groupId) => {
    try {
        const response = await fetchWithRetry('/api/groups/getById', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: groupId }),
        });

        if (!response.ok) {
            throw new Error(`Error fetching group by ID: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching group by ID:', error);
        throw error;
    }
};

// Function to update a group  
const updateGroup = async (groupId, data) => {
    try {
        const response = await fetchWithRetry(`/api/groups/${groupId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            const errorText = await response.text(); // Get detailed error message from the server  
            throw new Error(`Error updating group by ID: ${response.statusText} - ${errorText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating group by ID:', error);
        throw error;
    }
};

// Function to add a contestant to a group  
const addContestantToGroup = async (group_code, contestantId) => {
    try {
        const response = await fetchWithRetry('/api/groups/addContestant', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ group_code, contestantId }),
        });

        if (!response.ok) {
            throw new Error(`Error adding contestant to group: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error adding contestant to group:', error);
        throw error;
    }
};

// Function to search group by code  
const searchGroupByCode = async (group_code) => {
    try {
        const response = await fetchWithRetry('/api/groups/searchByCode', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ group_code }),
        });

        if (!response.ok) {
            throw new Error(`Error searching group by code: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error searching group by code:', error);
        throw error;
    }
};

// Function to get all groups' payment status  
const getAllGroupsPaymentStatus = async () => {  
    try {  
  
        // Construct the API endpoint with the round query parameter  
        const response = await fetchWithRetry(`/api/groups/paymentStatus`, {  
            method: 'GET',  
            headers: {},  
        });  
  
        if (!response.ok) {  
            throw new Error(`Error fetching payment status: ${response.statusText}`);  
        }  
  
        return await response.json();  
    } catch (error) {  
        console.error('Error fetching payment status:', error);  
        throw error;  
    }  
};  

const groupInviteEmail = async (email, groupCode) => {
    try {
        const response = await fetchWithRetry('/api/groups/groupInviteEmail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, groupCode }),
        })

        if (!response.ok) {
            throw new Error(`Error sending email: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error sending email: ', error);
        throw error;
    }
}

// Function to get the total number of groups  
const getTotalGroups = async () => {  
    try {  
        const response = await fetchWithRetry('/api/groups/totalNumber', {  
            method: 'GET',  
            headers: {},  
        });  
  
        if (!response.ok) {  
            throw new Error(`Error fetching total number of groups: ${response.statusText}`);  
        }  
  
        return await response.json();  
    } catch (error) {  
        console.error('Error fetching total number of groups:', error);  
        throw error;  
    }  
}; 

const updateGroupRound = async (groupId, roundNumber) => {  
    try {  
        const response = await fetchWithRetry(`/api/groups/${groupId}/round/${roundNumber}`, {  
            method: 'PATCH',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
        });  
        if (!response.ok) {  
            throw new Error(`Error updating group round: ${response.statusText}`);  
        }  
        return await response.json();  
    } catch (error) {  
        console.error('Error updating group round:', error);  
        throw error;  
    }  
};  

const getInvoicesByGroup = async (groupId, roundNumber) => {
    try {
        const body = { group: groupId };
        if (roundNumber) {
            body.roundNumber = roundNumber;
        }

        const response = await fetchWithRetry('/api/invoices/get/group', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            throw new Error(`Error fetching invoices: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching invoices:', error);
        throw error;
    }
};

const updateGroupMemberDetails = async (groupId, oldIdNumber, data) => {
  try {
    const response = await fetchWithRetry(
      `/api/groups/${groupId}/members/${encodeURIComponent(oldIdNumber)}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }
    );

    const responseBodyText = await response.text();
    let parsed;
    try {
      parsed = responseBodyText ? JSON.parse(responseBodyText) : {};
    } catch (e) {
      parsed = { raw: responseBodyText };
    }

    if (!response.ok) {
      const error = new Error(parsed.error || response.statusText);
      error.status = response.status;
      error.data = parsed;
      throw error;
    }

    return parsed;
  } catch (error) {
    console.error('Error updating group member details:', error);
    throw error;
  }
};


// api/group.js (or wherever uploadGroupPhotos is defined)
const uploadGroupPhotos = async (groupId, memberFiles) => {
  try {
    const formData = new FormData();

    Object.entries(memberFiles).forEach(([idNumber, file]) => {
      if (file) {
        // fieldname will be the member's id_number
        formData.append(idNumber, file);
      }
    });

    const response = await fetchWithRetry(`/api/groups/photos/${groupId}`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Error uploading photos: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error uploading group photos:', error);
    throw error;
  }
};

module.exports = {
    createGroup,
    searchGroups,
    searchGroupsByUser,
    getGroups,
    deleteGroup,
    getGroupById,
    updateGroup,
    addContestantToGroup,
    searchGroupByCode,
    getAllGroupsPaymentStatus,
    groupInviteEmail,
    getTotalGroups,
    updateGroupRound,
    getInvoicesByGroup,
    uploadGroupPhotos,
    updateGroupMemberDetails
};  